import axios from "axios";
const defaultSettings = require("../settings");

let headers = {
    companyType: defaultSettings.companyType
};

export const getCompany = () => {
    return getRequest("/api/officialWebsite/company/getCompany", {});
};

export const getAppInfoList = () => {
    return getRequest("/api/officialWebsite/appInfo/getAppInfoList", {});
};

export const getAppInfoDetails = id => {
    return getRequest("/api/officialWebsite/appInfo/getAppInfoDetails", {
        productId: id
    });
};

export const getSlideshow = () => {
    return getRequest("/api/officialWebsite/slideshow/getSlideshow", {});
};

export const getFriendlyLinks = () => {
    return getRequest("/api/officialWebsite/friendlyLinks/getFriendlyLinks", {});
};

export const getRequest = (url, params) => {
    return axios({
        method: "post",
        url: `${defaultSettings.baseURL}${url}`,
        data: params,
        headers: headers
    });
};
